import {toString} from 'es-toolkit/compat'

import * as dynamicProductionTimeApi from '../../../services/api/dynamic-production-time'
import {isMixedValue, toNumberValue, toPossiblyMixedValue, toStringValue} from '../../utils/form'

import {DynamicProductionTime, Provider, QuantityThresholdItem} from '../../../types'

import {MixedFormData, SingleFormData} from './form'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const formDataTransforms: Record<string, (value: any) => any> = {
  name: name => name,
  increaseSteps: toNumberValue,
  maxIncrease: toNumberValue,
  quantityThresholds: quantityThresholds =>
    quantityThresholds.map((threshold: {axisSize: string; qtyThreshold: string}) => ({
      axisSize: toNumberValue(threshold.axisSize),
      qtyThreshold: toNumberValue(threshold.qtyThreshold),
    })),
}

export const formDataToDynamicProductionTimeRequest = (
  formData: SingleFormData,
  provider: Provider
): dynamicProductionTimeApi.DynamicProductionTimeRequest => ({
  provider: provider.id,
  name: formDataTransforms.name(formData.name),
  increaseSteps: formDataTransforms.increaseSteps(formData.increaseSteps),
  maxIncrease: formDataTransforms.maxIncrease(formData.maxIncrease),
  quantityThresholds: formDataTransforms.quantityThresholds(formData.quantityThresholds),
})

export const formDataToPartialDynamicProductionTimeRequest = (
  formData: Partial<SingleFormData>
) => {
  const dynamicProductionTimeRequest: Partial<dynamicProductionTimeApi.DynamicProductionTimeRequest> =
    {}

  Object.keys(formData).forEach(key => {
    const value = formData[key as keyof SingleFormData]
    const dynamicProductionTimeRequestTransform = formDataTransforms[key]

    if (!isMixedValue(value) && dynamicProductionTimeRequestTransform) {
      dynamicProductionTimeRequest[
        key as keyof dynamicProductionTimeApi.DynamicProductionTimeRequest
      ] = dynamicProductionTimeRequestTransform(value)
    }
  })

  return dynamicProductionTimeRequest
}

const toQuantityThresholds = (value: QuantityThresholdItem[]) => {
  if (!value) return []

  return value.map(({axisSize, qtyThreshold}) => ({
    axisSize: toStringValue(axisSize),
    qtyThreshold: toStringValue(qtyThreshold),
  }))
}

export const dynamicProductionTimesToFormData = (
  dynamicProductionTimes: DynamicProductionTime[]
): MixedFormData => ({
  name: toPossiblyMixedValue(
    dynamicProductionTimes.map(item => item.name),
    toString
  ),
  increaseSteps: toPossiblyMixedValue(
    dynamicProductionTimes.map(item => item.increaseSteps),
    toStringValue
  ),
  maxIncrease: toPossiblyMixedValue(
    dynamicProductionTimes.map(item => item.maxIncrease),
    toStringValue
  ),
  quantityThresholds: toPossiblyMixedValue(
    dynamicProductionTimes.map(item => item.quantityThresholds),
    toQuantityThresholds
  ),
})
